// sso.service.ts
import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AuthenticationService } from '../../shared/services/authentication.service';

@Injectable({ providedIn: 'root' })
export class SsoService {
  constructor(private http: HttpClient) {}
  authService = inject(AuthenticationService);

  getSsoLink() {
    const token = this.authService.getUserToken();

    let options = { headers: new HttpHeaders( {
      'Content-type': 'application/json',
      'Authorization': `Bearer ${token}`}) };

    let body = {
        platform: 2
    };
    return this.http.post<{ url: string }>(environment.API_URL + '/api/sso/link', body, options);
  }
}
